import * as yup from 'yup';
import { areDatesOnTheSameDay } from 'utils/date';
import { compare3DigitsFloats } from 'utils/number';

export const receptionFormSchema = (
  pt: any,
  closureDate: Date | null,
  twoMonthAfterClosureDate: Date | null,
): yup.AnyObjectSchema =>
  yup.object().shape({
    netWeight: yup
      .number()
      .nullable()
      .typeError(pt('validation.netWeight.invalid'))
      .required(pt('validation.netWeight.required'))
      .moreThan(0, pt('validation.netWeight.invalid'))
      .test('weightSumValidation', pt('validation.netWeight.invalidSum'), (value, context) => {
        return (
          (!context.parent.grossWeight && !context.parent.tare) ||
          compare3DigitsFloats(context.parent.grossWeight, value + context.parent.tare)
        );
      }),
    grossWeight: yup
      .number()
      .transform(value => (isNaN(value) ? null : value))
      .nullable()
      .typeError(pt('validation.grossWeight.invalid'))
      .moreThan(0, pt('validation.grossWeight.invalid')),
    tare: yup
      .number()
      .transform(value => (isNaN(value) ? null : value))
      .nullable()
      .typeError(pt('validation.tare.invalid'))
      .min(0, pt('validation.tare.invalid')),
    receptionDate: yup
      .date()
      .typeError(pt('validation.date.invalid'))
      .nullable()
      .required(pt('validation.date.required'))
      .max(new Date(), pt('validation.date.previousThanToday'))
      .test('alreadyClosedMonth', pt('validation.date.alreadyClosedMonth'), (value, _) => {
        return !!closureDate && !!value && value > closureDate && !areDatesOnTheSameDay(value, closureDate);
      })
      .test('datePreviousThanClosure', pt('validation.date.previousThanClosure'), (value, _) => {
        return (
          !!twoMonthAfterClosureDate &&
          !!value &&
          (value <= twoMonthAfterClosureDate || areDatesOnTheSameDay(value, twoMonthAfterClosureDate))
        );
      }),
    receptionTime: yup
      .date()
      .typeError(pt('validation.time.invalid'))
      .nullable()
      .required(pt('validation.time.required'))
      .when('receptionDate', {
        is: (receptionDate: Date | null) => receptionDate && areDatesOnTheSameDay(receptionDate, new Date()),
        then: yup
          .date()
          .typeError(pt('validation.time.invalid'))
          .nullable()
          .max(new Date(), pt('validation.date.previousThanToday')),
      }),
    client: yup.string().required(pt('validation.requiredClient')),
    stream: yup.string().required(pt('validation.requiredStream')),
    proofOfWeightIdentifier: yup.string().nullable(),
  });
